import { Divider } from '@material-ui/core'
import { useEditArticleContext } from 'components/domain/addArticles/useEditArticleContext'
import { CustomTooltip } from 'components/facets'
import { ConditionBadge } from 'components/facets/ConditionBadge'
import { LanguageFlag } from 'components/facets/LanguageFlag'
import { useUser } from 'components/providers/UserProvider'
// import { ConditionBadge } from 'components/facets/ConditionBadge'
import multiLocation from 'img/multi-location.svg'
import { useInventoryStore } from 'lib/hooks/useInventoryStore'
import { calcPriceDiff, getPriceFormat } from 'lib/utils'
import * as React from 'react'
import {
  AppCurrency,
  CardExtraAttribute,
  CardLanguage,
  FINISH_TYPE_LABELS,
  flagCode,
  InventoryArticle,
  INVENTORY_ZOOM_LEVELS,
  isSingle,
  PricedInventoryArticle,
  TAXATION_ICON_VISIBILITY,
  TAXATION_SCHEME,
  TAXATION_SCHEME_CONVERSIONS,
} from 'shared'
import {
  ARTICLE_EDIT,
  BACKOFFICE_USER_STOCK,
  COLD_FOIL_ICON,
  COSMOS_HOLO_ICON,
  FIRST_EDITION_ICON,
  FOIL_ICON,
  ICE_CRACKED_HOLO_ICON,
  LINKED_LOT_ICON,
  LISTING_AND_APPRAISAL,
  MARGIN_TAXATION_ICON,
  MASTERBALL_HOLO_ICON,
  PLAYSET_ICON,
  POKEBALL_HOLO_ICON,
  PRICING_BOT,
  RAINBOW_FOIL_ICON,
  REVERSE_COSMOS_ICON,
  REVERSE_HOLO_ICON,
  REVERSE_ICE_CRACKED_ICON,
  REVERSE_MASTERBALL_ICON,
  REVERSE_POKEBALL_ICON,
  REVERSE_STAMPED_ICON,
  SIGNED_ICON,
  STAMPED_HOLO_ICON,
  STANDARD_TAXATION_ICON,
  STOCK_DISPLAY,
} from 'utils/constants'
import { PriceReportPresenter } from './PriceReportPresenter'

export const getExtraAttribute = (article: InventoryArticle) => {
  return (
    <div className="d-flex flex-row justify-content-start align-items-center w-100">
      {article.finishType === FINISH_TYPE_LABELS.COLD_FOIL && (
        <div id="ArticleEdit-isColdFoil" data-testid={`${FINISH_TYPE_LABELS.COLD_FOIL}`}>
          <img alt="foil" src={COLD_FOIL_ICON} />
        </div>
      )}
      {article.finishType === FINISH_TYPE_LABELS.RAINBOW_FOIL && (
        <div id="ArticleEdit-isRainbowFoil" data-testid={`${FINISH_TYPE_LABELS.RAINBOW_FOIL}`}>
          <img alt="foil" src={RAINBOW_FOIL_ICON} />
        </div>
      )}

      {article.finishType === FINISH_TYPE_LABELS.FOIL && (
        <div id="ArticleEdit-isFoil" data-testid={`${FINISH_TYPE_LABELS.FOIL}`}>
          <img alt="foil" src={FOIL_ICON} />
        </div>
      )}
      {article.finishType === FINISH_TYPE_LABELS.REVERSE_HOLO && (
        <div data-testid={`${FINISH_TYPE_LABELS.REVERSE_HOLO}`}>
          <img alt="foil" src={REVERSE_HOLO_ICON} />
        </div>
      )}

      {article.finishType === FINISH_TYPE_LABELS.STAMPED_HOLO && (
        <div data-testid={`${FINISH_TYPE_LABELS.STAMPED_HOLO}`}>
          <img alt="Stamped Holo" src={STAMPED_HOLO_ICON} />
        </div>
      )}

      {article.finishType === FINISH_TYPE_LABELS.REVERSE_STAMPED_HOLO && (
        <div data-testid={`${FINISH_TYPE_LABELS.REVERSE_STAMPED_HOLO}`}>
          <img alt="Reverse Stamped Holo" src={REVERSE_STAMPED_ICON} />
        </div>
      )}

      {article.finishType === FINISH_TYPE_LABELS.COSMOS_HOLO && (
        <div data-testid={`${FINISH_TYPE_LABELS.COSMOS_HOLO}`}>
          <img alt="Cosmos Holo" src={COSMOS_HOLO_ICON} />
        </div>
      )}

      {article.finishType === FINISH_TYPE_LABELS.REVERSE_COSMOS_HOLO && (
        <div data-testid={`${FINISH_TYPE_LABELS.REVERSE_COSMOS_HOLO}`}>
          <img alt="Reverse Cosmos Holo" src={REVERSE_COSMOS_ICON} />
        </div>
      )}

      {article.finishType === FINISH_TYPE_LABELS.ICE_CRACKED_HOLO && (
        <div data-testid={`${FINISH_TYPE_LABELS.ICE_CRACKED_HOLO}`}>
          <img alt="Ice Cracked Holo" src={ICE_CRACKED_HOLO_ICON} />
        </div>
      )}

      {article.finishType === FINISH_TYPE_LABELS.REVERSE_ICE_CRACKED_HOLO && (
        <div data-testid={`${FINISH_TYPE_LABELS.REVERSE_ICE_CRACKED_HOLO}`}>
          <img alt="Reverse Ice Cracked Holo" src={REVERSE_ICE_CRACKED_ICON} />
        </div>
      )}

      {article.finishType === FINISH_TYPE_LABELS.MASTERBALL_HOLO && (
        <div data-testid={`${FINISH_TYPE_LABELS.MASTERBALL_HOLO}`}>
          <img alt="Masterball Holo" src={MASTERBALL_HOLO_ICON} />
        </div>
      )}

      {article.finishType === FINISH_TYPE_LABELS.POKEBALL_HOLO && (
        <div data-testid={`${FINISH_TYPE_LABELS.POKEBALL_HOLO}`}>
          <img alt="Pokeball Holo" src={POKEBALL_HOLO_ICON} />
        </div>
      )}

      {article.finishType === FINISH_TYPE_LABELS.REVERSE_MASTERBALL_HOLO && (
        <div data-testid={`${FINISH_TYPE_LABELS.REVERSE_MASTERBALL_HOLO}`}>
          <img alt="Reverse Masterball Holo" src={REVERSE_MASTERBALL_ICON} />
        </div>
      )}

      {article.finishType === FINISH_TYPE_LABELS.REVERSE_POKEBALL_HOLO && (
        <div data-testid={`${FINISH_TYPE_LABELS.REVERSE_POKEBALL_HOLO}`}>
          <img alt="Reverse Pokeball Holo" src={REVERSE_POKEBALL_ICON} />
        </div>
      )}
      {article.isPlayset && (
        <div id={`playset`} data-testid={`${CardExtraAttribute.Playset}`}>
          <img alt="playset" src={PLAYSET_ICON} />
        </div>
      )}
      {article.isFirstEd && (
        <div data-testid={`${CardExtraAttribute.FirstEd}`}>
          <img alt="first edition" src={FIRST_EDITION_ICON} />
        </div>
      )}
      {article.isSigned && (
        <div id={`signed`} data-testid={`${CardExtraAttribute.Signed}`}>
          <img alt="signed" src={SIGNED_ICON} />
        </div>
      )}
    </div>
  )
}

export interface VisualArticleIconbarProps {
  openPriceSuggestDrawer?: (article: InventoryArticle, view?: 'buyPrice' | 'sellPrice') => void
  openReservedQuantityDrawer?: (article: InventoryArticle) => void
  revertArticleEdit?: (article: InventoryArticle) => void
  showLocations?: (article: InventoryArticle) => void
  article: InventoryArticle | PricedInventoryArticle
  displayOnly?: boolean
  onDeleteArticle?: (article: InventoryArticle) => void
  currency?: AppCurrency
  parentEl?: string
  showPrice?: (price: InventoryArticle['price'] | undefined | null, currency: AppCurrency) => string
}

export const VisualArticleIconbar = React.memo(function VisualArticleIconbar({
  openPriceSuggestDrawer,
  openReservedQuantityDrawer,
  showLocations,
  article,
  displayOnly = false,
  onDeleteArticle,
  currency = 'EUR',
  parentEl = '',
  showPrice,
}: VisualArticleIconbarProps): JSX.Element {
  const { user } = useUser()
  const { zoomLevel, defaultTaxationScheme, displayTaxationIcon } = useInventoryStore()

  const {
    quantity,
    isPlayset,
    isSigned,
    isFirstEd,
    condition,
    idLanguage,
    card,
    price,
    newPrice,
    newCondition,
    newIdLanguage,
    newQuantity,
    location,
    ptArticleReservedQuantity,
  } = article

  const { startEditingArticle } = useEditArticleContext()

  const handleLocationsClick = (e: React.MouseEvent, article: InventoryArticle): void => {
    e.stopPropagation()
    showLocations && showLocations(article)
  }

  const handleDeleteClick = (e: React.MouseEvent, article: InventoryArticle): void => {
    e.stopPropagation()
    onDeleteArticle && onDeleteArticle(article)
  }

  const handleOpenPriceSuggestDrawer = async (
    e: React.MouseEvent,
    article: InventoryArticle,
    view?: 'buyPrice' | 'sellPrice'
  ): Promise<void> => {
    e.stopPropagation()
    openPriceSuggestDrawer && openPriceSuggestDrawer(article, view)
  }

  const handleReservedQuantityClick = async (
    e: React.MouseEvent,
    article: InventoryArticle
  ): Promise<void> => {
    e.stopPropagation()
    openReservedQuantityDrawer && openReservedQuantityDrawer(article)
  }

  const displayLotIcon = (): boolean => {
    return (
      (user.featureFlags?.taxation ?? false) &&
      parentEl === LISTING_AND_APPRAISAL &&
      (!!article.purchaseEventId || !!article.hasPurchase)
    )
  }

  const newMarginTaxationQuantity = article.newMarginTaxationQuantity
  const newStandardTaxationQuantity = article.newStandardTaxationQuantity
  const hasNewTaxationEdit =
    !displayOnly &&
    (newMarginTaxationQuantity !== undefined || newStandardTaxationQuantity !== undefined)
  const oldHasMargin = (article.marginTaxationQuantity ?? 0) > 0
  const oldHasStandard = (article.standardTaxationQuantity ?? 0) > 0
  const newHasMargin = (newMarginTaxationQuantity ?? 0) > 0
  const newHasStandard = (newStandardTaxationQuantity ?? 0) > 0

  const displayTaxationSchemeIcon = (): boolean => {
    if (!user.featureFlags?.taxation || !user.enableMarginTaxation) return false
    if (defaultTaxationScheme === null || defaultTaxationScheme === undefined) {
      return false
    }

    // Force display during a pending edit so the user sees old → new
    if (hasNewTaxationEdit) return true

    // No taxed quantity -> no icons
    if (!oldHasMargin && !oldHasStandard) {
      return false
    }

    // Setting: Show icons on all articles
    if (displayTaxationIcon === TAXATION_ICON_VISIBILITY.ALL) {
      return true
    }

    // Setting: Show icons only on items that differ from the default
    if (displayTaxationIcon === TAXATION_ICON_VISIBILITY.ONLY_DIFFERENT) {
      if (defaultTaxationScheme === TAXATION_SCHEME.MARGIN && oldHasStandard) return true
      if (defaultTaxationScheme === TAXATION_SCHEME.STANDARD && oldHasMargin) return true
      return false
    }

    return false
  }

  const displayExtraAttributesIcon = (): boolean => {
    return article.finishType !== FINISH_TYPE_LABELS.REGULAR || isFirstEd || isPlayset || isSigned
  }

  const showLocation = () => {
    if (zoomLevel === INVENTORY_ZOOM_LEVELS.ARTICLE) {
      return (
        <>
          <Divider className="visual-article-divider" />
          <div className="d-flex flex-row align-items-center justify-content-start">
            <img src={multiLocation} className="multi-location" />
          </div>
        </>
      )
    } else if (zoomLevel === INVENTORY_ZOOM_LEVELS.LOCATION && location !== '') {
      if (location === '') {
        return
      } else
        return (
          <>
            <Divider className="visual-article-divider" />
            <div
              className="d-flex flex-row align-items-center justify-content-start"
              title={location}
            >
              <i className="fa-solid fa-location-dot" />
              <span className="location-name">{location}</span>
            </div>
          </>
        )
    }
  }

  const hasNewPrice = !!newPrice && newPrice !== price
  const articleBuyPrice = article.buyPrice
  const isPricedArticle = article instanceof PricedInventoryArticle
  const isListingAndAppraisal = parentEl === LISTING_AND_APPRAISAL
  const isStockDisplay = parentEl === STOCK_DISPLAY

  // The pricing bot view is a preview of what the bot did: the card is shown whole but nothing on
  // it leads anywhere, the way selection is already blocked for it below.
  const isInert = displayOnly || parentEl === PRICING_BOT

  const canEditPrice = !isInert && !hasNewPrice && (isStockDisplay || isListingAndAppraisal)
  const showBasePrice = price && showPrice
  const showNewPrice = hasNewPrice && showPrice
  const showBuyPriceRow =
    user.featureFlags?.taxation && (parentEl === LISTING_AND_APPRAISAL || parentEl === ARTICLE_EDIT)
  const hasBotFailure = isPricedArticle && article.priceReport?.failure

  return (
    <div className="visual-article-iconbar">
      <div className="d-flex flex-column justify-content-between h-100">
        <div className="h-100 gy-1 d-flex flex-column">
          {/* PRICE */}
          <div className={'price-container ' + (hasNewPrice ? 'text-center' : 'text-start')}>
            {showBasePrice && (
              <div
                className={
                  'd-flex ' +
                  (hasNewPrice
                    ? 'justify-content-center align-items-center'
                    : 'align-items-center justify-content-start')
                }
              >
                <span
                  data-testid="visual-article-price"
                  onClick={(e) => {
                    if (canEditPrice) {
                      handleOpenPriceSuggestDrawer(e, article)
                    }
                  }}
                  className={
                    hasNewPrice
                      ? 'visual-article-old-value'
                      : `visual-article-price ${canEditPrice ? 'visual-article-icon-button' : ''}`
                  }
                >
                  {user.featureFlags?.taxation && isListingAndAppraisal && (
                    <i className="fa-regular fa-circle-s price-icon"></i>
                  )}
                  {showPrice(price, currency)}
                </span>

                {canEditPrice && (
                  <i className="fa-regular fa-magnifying-glass primary-color price-search-icon" />
                )}
              </div>
            )}

            {/* New price */}
            {showNewPrice && (
              <div className="d-flex flex-column align-items-center mt-1">
                <i className="fa-regular fa-arrow-down"></i>

                {isPricedArticle ? (
                  <CustomTooltip title={<PriceReportPresenter priceReport={article.priceReport} />}>
                    <span
                      data-testid="visual-article-new-price"
                      className="visual-article-price visual-article-icon-button"
                      onClick={(e) => {
                        if (!isInert) {
                          handleOpenPriceSuggestDrawer(e, article)
                        }
                      }}
                    >
                      {showPrice(newPrice, currency)}
                    </span>
                  </CustomTooltip>
                ) : (
                  <span
                    data-testid="visual-article-new-price"
                    className="visual-article-price visual-article-icon-button"
                    onClick={(e) => {
                      if (!isInert) {
                        handleOpenPriceSuggestDrawer(e, article)
                      }
                    }}
                  >
                    {showPrice(newPrice, currency)}
                  </span>
                )}

                <span className="visual-article-price-diff">
                  ({calcPriceDiff(newPrice, price)}%)
                </span>
              </div>
            )}

            {/* Buy price */}
            {showBuyPriceRow && (
              <div
                className="w-100 d-flex align-items-center justify-content-start mt-1"
                onClick={(e) => {
                  if (!isInert && !hasNewPrice) {
                    handleOpenPriceSuggestDrawer(e, article, 'buyPrice')
                  }
                }}
              >
                <i className="fa-regular fa-circle-b secondary-color price-icon"></i>
                {articleBuyPrice !== undefined ? (
                  <span className="secondary-color">
                    {getPriceFormat(articleBuyPrice, currency)}
                  </span>
                ) : (
                  <span className="secondary-color">/</span>
                )}
              </div>
            )}

            {/* Bot pricing failure icon */}
            {hasBotFailure && (
              <div className="mt-1">
                <CustomTooltip title={<PriceReportPresenter priceReport={article.priceReport} />}>
                  <i
                    className="fa-regular fa-triangle-exclamation failed-bot-pricing-icon fa-beat"
                    data-testid="failed-bot-pricing-icon"
                  />
                </CustomTooltip>
              </div>
            )}
          </div>

          {/* QUANTITY */}
          <div
            className="visual-article-icon-button"
            onClick={(e) => {
              if (!isInert) {
                handleReservedQuantityClick(e, article)
              }
            }}
          >
            <Divider className="visual-article-divider" />

            {typeof newQuantity === 'number' ? (
              <div className="d-flex flex-column align-items-center">
                <span
                  data-testid="quantity"
                  className={
                    newQuantity && newQuantity !== quantity ? 'visual-article-old-value' : ''
                  }
                >
                  {quantity}x
                </span>
                <i className="fa-regular fa-arrow-down"></i>
                <span data-testid="new-quantity">{newQuantity}x</span>
              </div>
            ) : (
              <div className="w-100 text-start">
                <span data-testid="visual-article-quantity">
                  {`${quantity}x ${isStockDisplay ? 'in stock' : ''}`}
                </span>
              </div>
            )}

            <div className="sold-quantity w-100 text-start">
              {ptArticleReservedQuantity !== 0 && (
                <span data-testid="sold-quantity">{ptArticleReservedQuantity}x sold</span>
              )}
            </div>
          </div>

          {/* condition and language */}

          <div>
            <Divider className="visual-article-divider" />
            <div className="d-flex flex-row align-items-center py-1">
              {isSingle(card) && (
                <div className="me-1" data-testid="visual-article-condition">
                  <ConditionBadge condition={newCondition ? newCondition : condition} />
                </div>
              )}

              <LanguageFlag
                id={`${parentEl}-flag`}
                className={`${parentEl}-flag`}
                data-testid={`${CardLanguage[newIdLanguage ? newIdLanguage : idLanguage]}-flag`}
                code={flagCode(newIdLanguage ? newIdLanguage : idLanguage) || 'gg'}
              />
            </div>
          </div>

          {/* finish type  */}

          <div className={`finish-type ${displayExtraAttributesIcon() ? 'd-block' : 'd-none'}`}>
            <Divider className="visual-article-divider" />
            {getExtraAttribute(article)}
          </div>

          {/* location */}
          {!displayOnly && <div data-testid="location">{showLocation()}</div>}

          {/* grading  */}
          {article.graded.isGraded && (
            <>
              <Divider className="visual-article-divider mb-1" />
              {/* One flowing block rather than a flex row: a label like "10.0 Gold Label" does not fit
                  this column on one line, and with the icon inline the wrapped lines run under it
                  instead of being indented past it, which costs a line less. */}
              <div className="grading-info">
                <i className="fa-solid fa-fire grading-icon me-1"></i>
                <span data-testid={article.gradingCompany + '-' + article.grade}>
                  {article.gradingCompany} - {article.grade}
                </span>
              </div>
            </>
          )}

          <div className="taxation">
            <div
              className={`${
                !displayTaxationSchemeIcon() && !displayLotIcon() ? 'd-none' : 'd-block'
              }`}
            >
              <Divider className="visual-article-divider" />
            </div>

            <div
              className={`d-flex flex-row ${
                hasNewTaxationEdit ? 'justify-content-center' : 'justify-content-start'
              } align-items-center w-100`}
            >
              <div className={`${displayTaxationSchemeIcon() ? 'd-block' : 'd-none'}`}>
                {displayTaxationSchemeIcon() && (
                  <div
                    id={`${parentEl}-${article.taxationScheme}`}
                    data-testid={
                      TAXATION_SCHEME_CONVERSIONS.find(
                        (item) => item.code === article.taxationScheme
                      )?.label
                    }
                  >
                    {hasNewTaxationEdit ? (
                      <div className="d-flex flex-column align-items-center w-100">
                        <div className="d-flex justify-content-center">
                          {oldHasMargin && (
                            <img
                              alt="marginTaxation"
                              data-testid="margin-icon"
                              title="margin icon"
                              src={MARGIN_TAXATION_ICON}
                              className="visual-article-old-value"
                            />
                          )}
                          {oldHasStandard && (
                            <img
                              data-testid="standard-icon"
                              alt="standardTaxation"
                              title="standard icon"
                              src={STANDARD_TAXATION_ICON}
                              className="visual-article-old-value"
                            />
                          )}
                        </div>
                        <i className="fa-regular fa-arrow-down"></i>
                        <div className="d-flex justify-content-center">
                          {newHasMargin && (
                            <img
                              alt="marginTaxation"
                              data-testid="new-margin-icon"
                              title="margin icon"
                              src={MARGIN_TAXATION_ICON}
                            />
                          )}
                          {newHasStandard && (
                            <img
                              data-testid="new-standard-icon"
                              alt="standardTaxation"
                              title="standard icon"
                              src={STANDARD_TAXATION_ICON}
                            />
                          )}
                        </div>
                      </div>
                    ) : (
                      <>
                        {oldHasMargin && (
                          <img
                            alt="marginTaxation"
                            data-testid="margin-icon"
                            title="margin icon"
                            src={MARGIN_TAXATION_ICON}
                          />
                        )}

                        {oldHasStandard && (
                          <img
                            data-testid="standard-icon"
                            alt="standardTaxation"
                            title="standard icon"
                            src={STANDARD_TAXATION_ICON}
                          />
                        )}
                      </>
                    )}
                  </div>
                )}
              </div>

              {displayLotIcon() && (
                <div id={`${parentEl}-linked-lot`} data-testid={`linked-lot`}>
                  <img alt="linkedLot" title="linked purchase event icon" src={LINKED_LOT_ICON} />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* actions -- these are shown in the bottom part of the icon bar */}
        <div className="d-flex flex-row justify-content-evenly action-card-icons">
          {!displayOnly &&
            ![LISTING_AND_APPRAISAL, PRICING_BOT, BACKOFFICE_USER_STOCK].includes(parentEl) && (
              <i
                className="fa-regular fa-pen edit-card-icon"
                data-testid="locations-icon"
                onClick={(e) => handleLocationsClick(e, article)}
              />
            )}
          {!displayOnly && startEditingArticle && (
            <i
              className={`fa-regular fa-pen edit-card-icon`}
              data-testid="edit-article-changes-btn"
              onClick={(e) => {
                e.stopPropagation()

                startEditingArticle(article, false)
              }}
            />
          )}
          {!isInert && onDeleteArticle && (
            <i
              className="fa-regular fa-trash edit-card-icon"
              data-testid="delete-article-changes-btn"
              onClick={(e) => handleDeleteClick(e, article)}
            />
          )}
        </div>
      </div>
    </div>
  )
})
